import {
  SET_VENUE_QUERY,
  REQUEST_VENUES,
  REQUEST_INFINITE_VENUES,
  REQUEST_VENUE_NAMES,
  ADD_VENUE_NAMES_REQUEST,
  INFINITE_VENUES_SUCCESS,
  INFINITE_VENUES_FAILURE,
  RECEIVE_VENUES,
  RECEIVE_VENUE_NAMES,
  ADD_VENUE_NAMES_SUCCESS,
  SEARCH_VENUE_NAMES,
  ADD_INFINITE_VENUES_SUCCESS,
  UPDATE_VENUE_NAME_ON_LIST,
  SET_VENUE_FILTER,
  SET_VENUE_SELECTED_IDS_FOR_EXPORT,
} from 'Constants/redux';

const INITIAL_STATE = {
  isFetching: false,
  loading: false,
  shouldRefresh: true,
  pagesRemaining: false,
  items: [],
  names: [],
  fetchingNames: false,
  searchCancelToken: null,
  pagination: {},
  filter: {
    query: '',
    page: 1,
    numberPer: 10,
  },
  selectedIdsForExport: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REQUEST_VENUES:
      return {
        ...state,
        isFetching: true,
        shouldRefresh: true,
      };
    case REQUEST_VENUE_NAMES:
    case ADD_VENUE_NAMES_REQUEST:
      return {
        ...state,
        fetchingNames: true,
        shouldRefresh: true,
      };
    case RECEIVE_VENUES:
      return {
        ...state,
        isFetching: false,
        shouldRefresh: true,
        items: action.venues,
        lastUpdated: action.receivedAt,
      };
    case RECEIVE_VENUE_NAMES:
      const { names, pagination, firstId } = action.payload;
      return {
        ...state,
        isFetching: false,
        fetchingNames: false,
        shouldRefresh: true,
        names,
        firstId,
        pagination,
        pagesRemaining: names.length !== pagination.totalObjects,
        selectedIdsForExport: {},
      };
    case ADD_VENUE_NAMES_SUCCESS:
      const newPagination = action.payload.pagination;
      const newNames = [...state.names, ...action.payload.names];
      return {
        ...state,
        isFetching: false,
        fetchingNames: false,
        shouldRefresh: true,
        names: newNames,
        pagination: newPagination,
        pagesRemaining: newNames.length !== newPagination.totalObjects,
      };
    case SET_VENUE_QUERY:
      return {
        ...state,
        query: action.payload.query,
      };
    case UPDATE_VENUE_NAME_ON_LIST:
      const updatedNames = state.names;
      const venueIndex = updatedNames.findIndex(
        (venue) => venue.id === action.payload.id
      );
      updatedNames[venueIndex] = {
        ...updatedNames[venueIndex],
        name: action.payload.name,
      };
      return {
        ...state,
        names: updatedNames,
      };
    case INFINITE_VENUES_SUCCESS:
      const infVenues = action.payload.venues;
      const infPagination = action.payload.pagination;
      const infTotalVenues = infVenues;
      const infPagesRemaining =
        infTotalVenues.length !== infPagination.totalObjects;
      return {
        ...state,
        loading: false,
        pagination: infPagination,
        pagesRemaining: infPagesRemaining,
        items: infVenues,
      };
    case ADD_INFINITE_VENUES_SUCCESS:
      const addVenues = action.payload.venues;
      const addPagination = action.payload.pagination;
      const addTotalVenues = state.items.slice().concat(addVenues);
      const addPagesRemaining =
        addTotalVenues.length !== addPagination.totalObjects;
      return {
        ...state,
        loading: false,
        pagination: addPagination,
        pagesRemaining: addPagesRemaining,
        items: addTotalVenues,
      };
    case INFINITE_VENUES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case REQUEST_INFINITE_VENUES:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_VENUE_NAMES:
      return {
        ...state,
        query: action.query,
      };
    case SET_VENUE_FILTER:
      return {
        ...state,
        filter: action.filter,
      };
    case SET_VENUE_SELECTED_IDS_FOR_EXPORT:
      return {
        ...state,
        selectedIdsForExport: action.selectedIdsForExport,
      };
    default:
      return state;
  }
};
